module.exports = __webpack_public_path__ + "img/image (31).0cdeb671.jpg";